import IconButton from '../../UI/IconButton/IconButton';
import ColorLabel from '../../UI/ColorLabel/ColorLabel';
import type LabelGroup from '../../../entities/labelGroup';

import './WorkspaceLabelGroupRow.scss';

type WorkspaceLabelGroupRowProps = {
	group: LabelGroup,
	onEditClick: () => void
	onDeleteClick: () => void
	editDisabled?: boolean
	buttonsOnlyDisabled?: boolean
}

const WorkspaceLabelGroupRow = ( {
	group, onEditClick, onDeleteClick, editDisabled = false, buttonsOnlyDisabled = false
}: WorkspaceLabelGroupRowProps ) => {
	const buttonsDisabled = editDisabled || buttonsOnlyDisabled;

	return (
		<div key={group.id} className={`WorkspaceLabelGroupRow ${editDisabled ? 'disabled' : ''}`}>
			<div className="name">
				<p>{group.name}</p>
			</div>
			<div className="labels">
				{group.labels.map( label => (
					<ColorLabel
						key={label.name}
						text={label.name}
						backgroundColor={{
							base: label.baseColor,
							hovered: label.hoverColor
						}}
					/>
				) )}
			</div>
			<div className={`actions ${buttonsOnlyDisabled ? 'buttons-disabled' : ''}`}>
				<IconButton icon="edit" testID="edit-row-icon" onClick={onEditClick} disabled={buttonsDisabled} />
				<IconButton icon="delete" testID="delete-row-icon" onClick={onDeleteClick} disabled={buttonsDisabled} />
			</div>
		</div>
	);
};

export default WorkspaceLabelGroupRow;
